import React, { useCallback } from 'react'
import { useMuiSelectUtils } from 'scenes/Dashboard/components-next/Inputs/Select/Select.hook'

import { MenuItem, Select, SelectChangeEvent } from '@mui/material'

import { UserRole } from '../../../../../../entities-next/user'

export type UserRoleSelectorProps = {
  role?: UserRole
  onChange: (newSearch: UserRole) => void
}

export const UserRoleSelector = React.memo(({ onChange, role }: UserRoleSelectorProps) => {
  const menuItemsData = React.useMemo(
    () => [
      { value: '', text: 'All roles' },
      { value: UserRole.member, text: 'Member' },
      { value: UserRole.manager, text: 'Manager' },
      { value: UserRole.collaborator, text: 'Collaborator' },
    ],
    []
  )
  const selected = role ?? ''
  const { getItem, selectedItem, setSelectedItem } = useMuiSelectUtils(menuItemsData, selected)

  const onSelectChange = useCallback(
    (event: SelectChangeEvent<{ name?: string; value: unknown }>) => {
      const role = event.target.value as UserRole
      onChange(role)
      setSelectedItem(role)
    },
    [onChange]
  )

  return (
    <Select
      variant="standard"
      onChange={onSelectChange}
      value={getItem(selectedItem)}
      renderValue={() => getItem(selectedItem)?.text}
    >
      {menuItemsData.map((m) => (
        <MenuItem key={m.value} value={m.value}>
          {m.text}
        </MenuItem>
      ))}
    </Select>
  )
})

UserRoleSelector.displayName = 'UserRoleSelector'
